import React from 'react';
import {
  Card,
  CardHeader,
  CardSection,
  ReadonlyTextarea,
  SmallHeader,
} from '@axiom/ui';
import type { UseOnboardingTextReturn } from '@axiom/ui';

import type { Nullable } from '../../types/utility.types';

export type OnboardingResourcesProps = {
  name: string;
  resourcesText: Nullable<
    Pick<
      NonNullable<ReturnType<UseOnboardingTextReturn['getOnboardingTexts']>>,
      'resources'
    >
  >['resources'];
};

export const OnboardingLegalResources = ({
  name,
  resourcesText,
}: OnboardingResourcesProps) => {
  return (
    <Card name={name}>
      <CardHeader>
        <SmallHeader>Legal Resources</SmallHeader>
      </CardHeader>
      <CardSection>
        <ReadonlyTextarea
          name="commitment"
          value={resourcesText}
          formatting="modern"
        />
      </CardSection>
    </Card>
  );
};
